import './styles.scss'

import React from 'react'
import { useActions, useValues } from 'kea'

import TimeZonePicker from '~/scenes/shared/time-zone-picker'

import logic from '../../logic'

const TimeZone = () => {
  const { updateAvailabilityTimezone } = useActions(logic)
  const { timezone } = useValues(logic)

  return (
    <div className='course-timezone-picker'>
      <div className='white'>
        <TimeZonePicker timezone={timezone} onChange={updateAvailabilityTimezone} />
      </div>
    </div>
  )
}

export default TimeZone
